<template>
            <div class="text-center">
            <v-dialog>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-plus-box-outline</v-icon>
                    </v-btn>
                </template>
                <v-card>
                    <template v-if="agg">
										<v-toolbar dense :elevation="1">
											<v-toolbar-title v-if="agg == 'SchoolName'" class="subheading font-weight-bold">{{ item.SchoolName[0] }}</v-toolbar-title>
											<v-toolbar-title v-if="agg == 'CountryName'" class="subheading font-weight-bold">{{ item.CountryName[0] }}</v-toolbar-title>
											<v-toolbar-title v-if="agg == 'LicenseeName'" class="subheading font-weight-bold">{{ item.LicenseeName[0] }}</v-toolbar-title>
											<v-toolbar-title v-if="agg == 'FactoryName'" class="subheading font-weight-bold">{{ item.FactoryName[0] }}</v-toolbar-title>
											<v-spacer></v-spacer>
											<ResultSetModal :item="item" />
										</v-toolbar>
									</template>

									<templatev v-else>
										<v-toolbar dense :elevation="1">
											<v-toolbar-title class="subheading font-weight-bold">{{ item.FactoryName }}</v-toolbar-title>
											<v-spacer></v-spacer>
											<ResultSetModal :item="item" />
										</v-toolbar>
									</templatev>		
									

									<!-- Card Content -->
									<v-divider></v-divider>
									<v-list dense>
										<v-list-item>
											<v-list-item-content :class="{ 'blue--text': (sortBy + 'Name') == key }">Disclosure Date:</v-list-item-content>
											<v-list-item-content>{{ displayDate(item) }}</v-list-item-content>
										</v-list-item>
									</v-list>
									<v-divider></v-divider>

									<v-list dense>
										<v-list-item
											v-for="(key, index) in [
                                            'FactoryName',
											'LicenseeName',
											'CountryName',
											]"
											:key="index"
										>
											<v-list-item-content :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ getLabel(key) }}:</v-list-item-content>
											<template v-if="Array.isArray(item[key])">
												<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ reduceArray(item[key]) }}</v-list-item-content>
											</template>
											<template v-else>
												<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ item[key] }}</v-list-item-content>
											</template>
										</v-list-item>
									</v-list>
									<v-divider></v-divider>

									<v-expansion-panels>
										<v-expansion-panel>
										<v-expansion-panel-header>
											<h3>School</h3>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-list v-if="item.SchoolName" dense>
												<template v-if="Array.isArray(item.SchoolName)">
													<v-list-item>
														<v-list-item-content>{{ reduceArray(item.SchoolName) }}</v-list-item-content>
													</v-list-item>
												</template>
												<template v-else>
													<v-list-item v-for="school in item.SchoolName.split(',')" :key="school">
														<v-list-item-content>{{ school }}</v-list-item-content>
													</v-list-item>
												</template>
												
											</v-list>
										</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
									<v-divider></v-divider>
									
										<v-expansion-panels>
											<v-expansion-panel>
												<v-expansion-panel-header>
													<h3>Address & Contact Info</h3>
												</v-expansion-panel-header>
												<v-expansion-panel-content>
													<v-list dense>
														<v-list-item
															v-for="(key, index) in [
															'ContactName',
															'ContactPhone',
															'ContactEmail',
															'ContactFax',
															]"
															:key="index"
														>
															<v-list-item-content :class="{ 'blue--text': sortBy === key }">{{ getLabel(key) }}:</v-list-item-content>
															<template v-if="Array.isArray(item[key])">
																<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ reduceArray(item[key]) }}</v-list-item-content>
															</template>
															<template v-else>
																<v-list-item-content class="align-end" :class="{ 'blue--text': (sortBy + 'Name') == key }">{{ item[key] }}</v-list-item-content>
															</template>
														</v-list-item>
														<v-list-item>
															<v-list-item-content :class="{ 'blue--text': sortBy === key }">Address:</v-list-item-content>
															<template v-if="Array.isArray(item.Address1)">
																<v-list-item-content class="align-end" :class="{ 'blue--text': sortBy === key }">
																{{ reduceArray(item.Address1) }}<br />
																{{ reduceArray(item.Address2) }}<br v-if="item.Address2[0]" />
																{{ reduceArray(item.Address3) }}<br v-if="item.Address3[0]" />
																{{ reduceArray(item.City) }}, {{ reduceArray(item.State) }} {{ reduceArray(item.Zip) }}</v-list-item-content>
															</template>
															<template v-else>
																<v-list-item-content class="align-end" :class="{ 'blue--text': sortBy === key }">
																{{ item.Address1 }}<br />
																{{ item.Address2 }}<br v-if="item.Address2" />
																{{ item.Address3 }}<br v-if="item.Address3" />
																{{ item.City }}, {{ item.State }} {{ item.Zip }}</v-list-item-content>
															</template>
															
														</v-list-item>
													</v-list>
												</v-expansion-panel-content>
											</v-expansion-panel>
										</v-expansion-panels>
										

	
									<v-divider></v-divider>

									
									<v-expansion-panels>
										<v-expansion-panel>
										<v-expansion-panel-header>
											<h3>Products</h3>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-list v-if="item.Products" dense>
												<template v-if="Array.isArray(item.Products)">
													<v-list-item>
														<v-list-item-content>{{ reduceArray(item.Products) }}</v-list-item-content>
													</v-list-item>
												</template>
												<template v-else>
													<v-list-item v-for="product in item.Products.split(',')" :key="product">
														<v-list-item-content>{{ product }}</v-list-item-content>
													</v-list-item>
												</template>
												
											</v-list>
										</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
									<v-divider></v-divider>

									<v-expansion-panels>
										<v-expansion-panel>
										<v-expansion-panel-header>
											<h3>Business Type</h3>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-list v-if="item.BusAssocs" dense>
												<template v-if="Array.isArray(item.BusAssocs)">
													<v-list-item>
														<v-list-item-content>{{ reduceArray(item.BusAssocs) }}</v-list-item-content>
													</v-list-item>
												</template>
												<template v-else>
													<v-list-item v-for="assoc in item.BusAssocs.split(',')" :key="assoc">
														<v-list-item-content>{{ assoc }}</v-list-item-content>
													</v-list-item>
												</template>
											</v-list>
										</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
									<v-divider light></v-divider>
                    </v-card>
                </v-dialog>
            </div>
</template>
									
<script>
import _ from 'lodash';
export default {
	
	props: ["item", "agg"],
	methods: {
        // reminder: research if methods can be sent from parent to child. If so, consider refactoring. 
		getLabel (key) {
			let labels = {
            'FactoryName': 'Factory',
			'LicenseeName': 'Licensee',
			'SchoolName': 'School',
			'CountryName': 'Country',
			'ContactName': 'Contact',
			'ContactPhone': 'Phone',
			'ContactFax': 'Fax',
			'ContactEmail': 'Email'
		};
		return labels[key] ? labels[key] : key;
		},
		displayDate (item) {
			if(Array.isArray(item.DisclosureDate)){
				let date = item.DisclosureDate[0].replace(/T.*$/, '').split('-').reverse().join('/');
				return (new Date(date)).toLocaleDateString();
			}
			let date = item.DisclosureDate.replace(/T.*$/, '').split('-').reverse().join('/');
			return (new Date(date)).toLocaleDateString();
		}, 
        reduceArray (item){
			return _.uniq(item).join(', ')
			
        }
    }
}
</script>
<style>
.controls {
	padding: 1em;
}
h4 {
	padding: 1em 0 1em 1.5em;
}
</style>
